import { render, staticRenderFns } from "./TDSStatus.vue?vue&type=template&id=50e52288&"
import script from "./TDSStatus.vue?vue&type=script&lang=js&"
export * from "./TDSStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports